import { LoadingButton } from '@mui/lab';
import { Box, Button } from '@mui/material';
import { useQueryClient } from '@tanstack/react-query';
import { useSnackbar } from 'notistack';
import { useForm } from 'react-hook-form';
import { GeneralUpload } from 'src/components/general';
import { FormProvider, RHFTextField } from 'src/components/hook-form';
import { TRANSACTION_AMOUNT_TYPE_LIST } from 'src/constants/queryKeys';
import { networkCreateTransactionAmountType, networkUpdateTransactionAmountType } from 'src/network/transactionAmountType';
import useFormsModalStore from 'src/store/forms';
import { getDefaultValues } from './defaultValues';

const TransactionAmountTypeForm = () => {
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();

  const { modal, closeModal } = useFormsModalStore();

  const isEditMode = !!modal?.data;

  const transactionAmountTypeDetails = modal?.data;

  const defaultValues = getDefaultValues(transactionAmountTypeDetails);

  const methods = useForm({
    // resolver: yupResolver(schema), // todo schema
    defaultValues,
  });

  const {
    reset,
    handleSubmit,
    formState: { isSubmitting },
    setValue,
    trigger,
  } = methods;

  const onSubmit = async (values, event) => {
    const PAYLOAD = {
      ...values,
    };

    try {
      if (isEditMode) {
        const res = await networkUpdateTransactionAmountType(transactionAmountTypeDetails?.TransactionAmountTypeID, PAYLOAD);
        if (res.data?.items?.ResultID !== -1) {
          enqueueSnackbar('آیتم موردنظر با موفقیت ویرایش شد');
          if (event.nativeEvent.submitter.name === 'save') {
            closeModal();
            reset();
            await queryClient.invalidateQueries({ queryKey: [TRANSACTION_AMOUNT_TYPE_LIST] });
          }
        } else {
          enqueueSnackbar(res.data?.items?.Desc, { variant: 'error' });
        }
      } else {
        const res = await networkCreateTransactionAmountType(PAYLOAD);
        if (res.data?.items?.ResultID !== -1) {
          enqueueSnackbar('آیتم موردنظر با موفقیت ایجاد شد');
          if (event.nativeEvent.submitter.name === 'save') {
            closeModal();
            await queryClient.invalidateQueries({ queryKey: [TRANSACTION_AMOUNT_TYPE_LIST] });
          }
          reset();
        } else {
          enqueueSnackbar(res.data?.items?.Desc, { variant: 'error' });
        }
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
      <Box
        sx={{
          display: 'grid',
          columnGap: 2,
          rowGap: 3,
          gridTemplateColumns: { xs: 'repeat(1, 1fr)', sm: 'repeat(2, 1fr)' },
          mt: 2,
        }}
      >
        <RHFTextField name="TransactionAmountTypeLable" type="text" label="عنوان" />

        <GeneralUpload
          label="لوگو"
          id="transaction_amount_type_logo"
          name="TransactionAmountTypeLogo"
          afterChangeAction={(res) => {
            setValue('TransactionAmountTypeLogo', res);
            trigger('TransactionAmountTypeLogo');
          }}
        />
      </Box>

      <RHFTextField name="TransactionAmountTypeHelp" multiline rows={6} label="توضیحات" maxCharacters={1500} sx={{ mt: 2 }} />

      <div className="flex items-center gap-4 mt-6">
        <LoadingButton type="submit" variant="contained" name="save" loading={isSubmitting}>
          ذخیره
        </LoadingButton>
        <LoadingButton type="submit" variant="contained" color="info" name="saveAndContinue" loading={isSubmitting}>
          {isEditMode ? 'ذخیره و ادامه ویرایش' : 'ذخیره و ایجاد بعدی'}
        </LoadingButton>
        <Button onClick={closeModal} variant="contained" color="error">
          انصراف
        </Button>
      </div>
    </FormProvider>
  );
};

export default TransactionAmountTypeForm;
